export default __webpack_public_path__ + "static/media/cirun-runners.fad48721.png";